import styled from '@emotion/styled';
import useTranslation from 'Hooks/useTranslation';

// Components
import Column from 'Components/Column';
import Text from 'Components/Text';
import { Div } from 'Components/Div';

// Icons
import EditNoteIcon from '@mui/icons-material/EditNote';
import EditIcon from '@mui/icons-material/Edit';

// Others
import { colors } from 'Constants/Colors';
import { alpha } from '@mui/system';
import IconButton from '@mui/material/IconButton';
import { Button, Paper, Typography } from '@mui/material';
import { Save, Cancel } from '@mui/icons-material';
// ==============================
// = Styled Components
// ==============================

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 70px;
  width: 70px;
  background-color: ${alpha(colors.GREEN, 0.2)};
  border-radius: 10px;
`;

const Title = styled(Text)`
  font-size: 20px;
  font-weight: 600;
  color: ${colors.BLACK};
`;

const EvaluationType = styled(Text)`
  font-size: 14px;
  font-weight: 400;
  color: ${alpha(colors.BLACK, 0.5)};
`;

const CustomIconButton = styled(IconButton)`
  background-color: ${alpha(colors.GREEN, 0.2)};
  border-radius: 50%;

  &:hover {
    background-color: ${alpha(colors.GREEN, 0.3)};
  }
`;

// ==============================
// = Component
// ==============================

interface Props {
  title: string;
  evaluationType: string;
  disabled: boolean;
  onClickEdit: () => void;
  onClickCancel: () => void;
  onClickSave: () => void;
}

const CoursesLessonsHeader = ({
  title,
  evaluationType,
  onClickEdit,
  onClickCancel,
  onClickSave,
  disabled = false,
}: Props) => {
  // Dictionary
  const { t2 } = useTranslation('courses_lessons');

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden', borderRadius: '20px', padding: '20px 40px' }}>
      <Div display="flex" alignItems="center" height="100px" width="100%" gap="20px" backgroundColor={colors.WHITE}>
        <IconWrapper>
          <EditNoteIcon sx={{ fontSize: '50px', color: colors.GREEN }} />
        </IconWrapper>
        <Div display="flex" alignItems="center" justifyContent="space-between" width="100%">
          <Column gap="5px">
            <Title>{title}</Title>
            <EvaluationType>{evaluationType}</EvaluationType>
          </Column>
          {disabled ? (
            <CustomIconButton onClick={onClickEdit}>
              <EditIcon sx={{ fontSize: '20px', color: colors.GREEN }} />
            </CustomIconButton>
          ) : (
            <Div display="flex" alignItems="center" gap="10px">
              <Button onClick={onClickCancel} startIcon={<Cancel sx={{ fontSize: '20px', color: colors.RED }} />}>
                <Typography sx={{ fontSize: '12px', color: colors.RED }}>{t2('table.cancel')}</Typography>
              </Button>
              <Button onClick={onClickSave} startIcon={<Save sx={{ fontSize: '20px', color: colors.GREEN }} />}>
                <Typography sx={{ fontSize: '12px', color: colors.GREEN }}>{t2('table.save')}</Typography>
              </Button>
            </Div>
          )}
        </Div>
      </Div>
    </Paper>
  );
};

export default CoursesLessonsHeader;
